var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AUTH_MESSAGE_NAME, LOGOUT_MESSAGE_NAME, SUCCESS_STATUS } from "../constants";
import { log } from "./logs";
const TIMEOUT_MS = 15000;
const generalIframeFn = (authUrl, messageName, dataValidationFn, enableLogs) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const iframe = window.document.createElement("iframe");
        iframe.setAttribute("width", "0");
        iframe.setAttribute("height", "0");
        iframe.style.display = "none";
        log(enableLogs, "Created iFrame successfully...");
        const timeout = setTimeout(() => {
            window.removeEventListener("message", iframeEventHandler, false);
            window.document.body.removeChild(iframe);
            log(enableLogs, "Fetching token took too long... aborting");
            reject(new Error("Token not fetched in time"));
        }, TIMEOUT_MS);
        const iframeEventHandler = (e) => {
            if (!ensureValidHostname(e.origin)) {
                log(enableLogs, "Invalid hostname, ignoring...", e);
                return;
            }
            if (e.data.type !== messageName) {
                log(enableLogs, "Message type wrong, ignoring...", e);
                return;
            }
            log(enableLogs, "[SUCCESS] Message received with correct origin and type...", e);
            clearTimeout(timeout);
            window.removeEventListener("message", iframeEventHandler, false);
            window.document.body.removeChild(iframe);
            const validData = dataValidationFn(e);
            log(enableLogs, `Valid data: ${validData}`);
            if (validData) {
                resolve(e.data.response);
            }
            else {
                reject(new Error(e.data.response.error));
            }
        };
        iframe.onload = () => {
            if (!iframe.contentWindow) {
                clearTimeout(timeout);
                window.removeEventListener("message", iframeEventHandler, false);
                window.document.body.removeChild(iframe);
                log(enableLogs, "iFrame error, no contentWindow");
                reject(new Error("Unsupported browser, no contentWindow"));
            }
            else {
                log(enableLogs, "iFrame navigated to correct page, posting message:", messageName);
                iframe.contentWindow.postMessage({ type: messageName }, "*");
            }
        };
        window.addEventListener("message", iframeEventHandler, false);
        log(enableLogs, "Added eventListener to iFrame");
        window.document.body.appendChild(iframe);
        log(enableLogs, "Appended iFrame to document");
        iframe.setAttribute("src", `${authUrl}/authorization.html`);
        log(enableLogs, `Navigated to authorization page: ${authUrl}/authorization.html`);
    });
});
function ensureValidHostname(origin) {
    const { hostname } = window.location;
    const timeEditDomain = hostname.substring(hostname.lastIndexOf("timeedit."));
    const allowedDomains = ["localhost", timeEditDomain, "timeedit.net"];
    const eventHostname = new URL(origin).hostname;
    return allowedDomains.some((d) => eventHostname.endsWith(d));
}
export const runLoginIframe = (authUrl, enableLogs) => generalIframeFn(authUrl, AUTH_MESSAGE_NAME, (e) => { var _a; return !!(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.response) && !e.data.response.error); }, enableLogs);
export const runLogoutIframe = (authUrl, enableLogs) => generalIframeFn(authUrl, LOGOUT_MESSAGE_NAME, (e) => { var _a, _b, _c; return !!(((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.response) && ((_c = (_b = e === null || e === void 0 ? void 0 : e.data) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.status) === SUCCESS_STATUS); }, enableLogs);
